import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getConfirmPasswordValidator } from '../utils/helpers';

export function useConfirmPasswordValidator(passwordField: string) {
  const { t } = useTranslation();

  const validator = React.useCallback(
    getConfirmPasswordValidator(passwordField, t('CONFIRM_PASSWORD_ERROR') as string),
    [t]
  );

  return validator;
}
